/**
 * OverallLegends
 * 
 * @Author: Focci
 * @Date: 2024-11-08 11:15:29
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-08 11:15:29
 */

// import PropTypes from 'prop-types'
import { isArray } from 'lodash-es'
import { PercentageBar } from '../../panel/HotmapController'
import { Legend } from '../../panel/PanelBody'
import OverallItemScoff from '../OverallItemScoff'

function OverallLegend({ data }) {
  return isArray(data?.options) && (
    <div className="grid grid-cols-1 gap-2">
      {data.options.map((item) => {
        if(item.type === 'steps') {
          return (
            <div>
              {data.subTitle && <div className="-m-1 -mt-2 mb-1 text-helper">{data.subTitle}</div>}
              <PercentageBar steps={item.steps} />
            </div>
          )
        }
        
        return (
          <div key={item.key} className="flex items-center gap-2">
            <div className="shrink-0">
              <Legend data={item.legend} />
            </div>
            <span className="flex-auto text-f.6 text-meta leading-tight">
              {item.label}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default function OverallLegends({ legends }) {
  return (
    <div className="pt-1 pb-2">
      {legends.map((legend) => (
        <OverallItemScoff 
          key={legend.label} 
          title={legend.label} 
          stowable={false}
          expanding
        >
          <OverallLegend data={legend} />
        </OverallItemScoff>
      ))}
    </div>
  )
}

// OverallLegends.propTypes = {
//   className: PropTypes.string,
// }
